import app from 'firebase/app';
import 'firebase/auth';

const config = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
};

class Firebase {
  constructor() {
    app.initializeApp(config);
    this.auth = app.auth();
  }

  sendPasswordRecover = async (email) => {
    const response = await this.auth.sendPasswordResetEmail(email)
      .then(() => {
        return true;
      }).catch((error) => {
        console.log('Erro em Recover', error);
        return false;
      });
      return response;
  } 

  
  doReauthenticateWithCredential = (password )=>{
    // console.log(this.auth.currentUser?.email, 'EMAIL DA CONTA LOGADA');
    var credential = app.auth.EmailAuthProvider.credential(this.auth.currentUser?.email, password)
    return this.auth.currentUser.reauthenticateWithCredential(credential)
  } 
  
    // *** Auth API ***
  doCreateUserWithEmailAndPassword = (email, password) =>
    this.auth.createUserWithEmailAndPassword(email, password);

  doSignInWithEmailAndPassword = (email, password) =>
    this.auth.signInWithEmailAndPassword(email, password);

  doSignOut = () => this.auth.signOut();

  doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

  doPasswordUpdate = password =>
    this.auth.currentUser.updatePassword(password);

  doDeleteUser = () => this.auth.currentUser.delete();

  doEmailUpdate = email =>
    this.auth.currentUser.updateEmail(email)
}

export default Firebase;
